import React from "react";
import { RiCloseFill } from "react-icons/ri";
import "./InactivityWarningModal.css";

const InactivityWarningModal = ({
  remainingTime,
  formatTime,
  onStayLoggedIn,
}) => {
  return (
    <div className="inactivity-modal-overlay">
      <div className="inactivity-modal-content">
        <div className="inactivity-modal-header">
          <h2>⚠️ Session Timeout Warning</h2>
        </div>

        <div className="inactivity-modal-body">
          <p className="inactivity-warning-text">
            You have been inactive for a while. For your security, you will be
            automatically logged out in:
          </p>

          <div className="inactivity-countdown">
            <span className="countdown-time">{formatTime(remainingTime)}</span>
            <span className="countdown-label">minutes</span>
          </div>

          <p className="inactivity-instruction">
            Click the button below or move your mouse to stay logged in.
          </p>
        </div>

        <div className="inactivity-modal-footer">
          <button className="stay-logged-in-btn" onClick={onStayLoggedIn}>
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  );
};

export default InactivityWarningModal;
